import React from 'react';
import Email from '../../common/email';
import { PrimaryNormalText } from '../../common/typography';
import { Box, Stack, Typography } from '@mui/material';
import NoPermission from './no-permission';
import Authorized from './authorized';
import LocalStorage from 'utils/extension/localstorage';

const Consent = ({ email = '', onClick = () => {}, authorization, isSingleCompany = false }) => {
    const company = LocalStorage.getSelectedCompany();
    const companyName = company?.legalBusinessName;

    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1} height="100%">
            <Stack direction="row" alignItems="center" gap={0.5}>
                <Email email={email} />
                <Typography className="font-base fw-700 font-roboto" style={{ color: '#9E9E9E' }}>
                    .
                </Typography>
                <Typography className="font-base fw-700 font-roboto" style={{ color: '#9E9E9E' }}>
                    {companyName}
                </Typography>
            </Stack>
            {(!authorization.hasPermission || !authorization.hasSetup) && (
                <NoPermission authorization={authorization} isSingleCompany={isSingleCompany} onClick={onClick} />
            )}

            {authorization.hasPermission && authorization.hasSetup && (
                <Authorized authorization={authorization} isSingleCompany={isSingleCompany} onClick={onClick} />
            )}
        </Box>
    );
};

export default Consent;
